'use client';
import { RefreshCwIcon } from 'lucide-react';
import Logo from '~/components/layout/header/logo';
import { Button } from '~/components/ui/button';
import { cn } from '~/lib/utils';
import '~/styles/globals.css';
import {
  getBrandIdFromUrl,
  getBrandThemeNameFromId,
} from '~/utils/theme-client-safe';

export default function GlobalError({}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const brandId = getBrandIdFromUrl(window.location.hostname);
  const theme = getBrandThemeNameFromId(brandId);
  return (
    <html lang="en" className={cn(theme, 'error-page font-sans')}>
      <body>
        <div className="bg-[var(--site-header-bg-color)] text-[var(--site-header-text-color)]">
          <div className="container mx-auto flex h-full px-0 py-2 sm:px-4 md:px-8">
            <Logo theme={theme} />
          </div>
        </div>

        <main className="mt-6 flex min-h-[8-vh] flex-col items-center justify-center px-4 text-center">
          <h1 className="text-9xl font-extrabold text-primary">500</h1>
          <h2 className="mt-4 text-2xl font-semibold">Server Error</h2>
          <p className="mt-2 max-w-md">
            An error occurred while trying to display this page.
          </p>
          <div className="mt-8 flex gap-6">
            <Button
              onClick={
                // Attempt to recover by trying to re-render the segment
                () => window.location.reload()
              }
            >
              <RefreshCwIcon className="mr-2 h-4 w-4" /> Retry
            </Button>
          </div>
        </main>
      </body>
    </html>
  );
}
